import { Language } from '@yleisradio/areena-types';
import { createMarkup } from '../common/createMarkup';

export async function htmlContentFetcher(uri: string) {
  if (!uri.length) {
    throw new Error('URL is required to fetch HTML content');
  }

  const response = await fetch(uri, { cache: 'force-cache' });

  if (!response.ok) {
    throw new Error('Fetching HTML content failed');
  }

  const htmlText = await response.text();
  return createMarkup(htmlText);
}

export const getInstructionsKeyGetter = (languageCode: Language) => () =>
  instructionUrls[languageCode] || null;

const instructionUrls = {
  fi: 'https://static.cdn.yle.fi/10m/mobile-config/help/areena-lg/index_fi.html',
  sv: 'https://static.cdn.yle.fi/10m/mobile-config/help/areena-lg/index_sv.html',
};
